import styled from "styled-components";
import { theme } from "../../styles/theme";

const statusColors = {
  completed: theme.colors.status.success,
  failed: theme.colors.status.error,
  pending: theme.colors.status.warning,
  fetching: theme.colors.status.warning,
  analyzing: theme.colors.status.info,
  generating: theme.colors.status.info,
  upscaling: theme.colors.status.info,
  image_ready: theme.colors.status.info,
  image: theme.colors.status.info,
  remixing: theme.colors.status.warning,
  prompt_pending: theme.colors.status.warning,
  rendering: theme.colors.status.info,
  post_processing: theme.colors.status.info,
  seed: theme.colors.status.info,
  video: theme.colors.status.info,
  default: theme.colors.status.neutral,
};

export const StatusBadge = styled.span`
  display: inline-flex;
  align-items: center;
  gap: ${theme.spacing["2xs"]};
  padding: 2px ${theme.spacing.xs};
  border-radius: ${theme.borderRadius.sm};
  font-size: ${theme.typography.fontSize.xs};
  font-weight: ${theme.typography.fontWeight.medium};
  text-transform: capitalize;
  letter-spacing: 0.02em;
  color: ${({ status }) => statusColors[status] || statusColors.default};
  border: 1px solid
    ${({ status }) => (statusColors[status] || statusColors.default) + "33"};
  background-color: ${({ status }) =>
    (statusColors[status] || statusColors.default) + "14"};
  width: fit-content;

  &::before {
    content: "";
    width: 5px;
    height: 5px;
    border-radius: 50%;
    background-color: currentColor;
    display: inline-block;
  }
`;


